import React from 'react';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import JobJournalCommentsDialog from './JobJournalCommentsDialog';

export default withRouter(function JobJournalCommentsIcon(props){
    const { project,jobJournalRow} = props;
    function commentsConfirm(project){
        confirmAlert({
            customUI: ({onClose}) => {
                return(
                    <JobJournalCommentsDialog onClose={onClose} projectId={project.id} project={project} formId={jobJournalRow.id}/>
                );
            }
        });
    }
    return(
        <FontAwesomeIcon id={"cmticon"}
                         icon={faCommentDots} pull={"right"} size ="lg" style={{cursor:'pointer'}}
                         onClick={() =>  commentsConfirm(project)}>Comment</FontAwesomeIcon>


    )
})
